
    <form [formGroup]="formOrderCode" >
        <div class="grid lg:grid-cols-3 gap-x-10 gap-y-0 items-center">
            <h3 class="col-span-3 text-white! m-0"> 
                <!--i18n: My order number -->
                {{ 'i18n.app.features.pages.front-pages.common.fp-order-panel.fp-order-tracking.h3_01' | translate }}
            </h3>
            <div class="col-span-2"><ng-container *ngTemplateOutlet="tp_order_code"></ng-container></div>

            <button 
                type="submit" 
                class="block w-full lg:text-[15px] xl:text-md py-[12px] px-[17px] bg-primary-600 text-white rounded-md transition-all font-medium hover:bg-primary-500
                disabled:cursor-not-allowed disabled:bg-gray-400 disabled:opacity-60"
                [disabled] = "formOrderCode.invalid || _orderTrackingService.loading$()"
                (click)="search()">
                <span class="inline-block relative ltr:pl-[25px] rtl:pr-[25px] ltr:md:pl-[29px] rtl:md:pr-[29px]">
                    <i class="material-symbols-outlined absolute ltr:left-0 rtl:right-0 top-1/2 -translate-y-1/2 !text-[20px] md:!text-xl">
                        track_changes
                    </i>
                    <!--i18n: Track my order -->
                    {{ 'i18n.app.features.pages.front-pages.common.fp-order-panel.fp-order-tracking.span_01' | translate }}
                </span>
            </button>
            
            @if(_orderTrackingService.businessException$()!=null) {
                <div class="col-span-2 bg-gray-50 border border-gray-200 text-gray-700 rounded-xl p-4">
                    
                    <div class="flex items-center gap-3">

                        <span class="material-symbols-outlined text-danger-400 text-xl">
                        deployed_code_alert
                        </span>

                        <p class="font-medium">
                        {{ 'i18n.app.features.pages.front-pages.common.fp-order-panel.fp-order-tracking.p_01' | translate }}
                        </p>

                    </div>

                    <li  class="flex gap-2">
                            @for(err of _orderTrackingService.businessException$(); track err.code) {
                                <span class="text-danger-500">•</span>
                                <span>{{ err.label | translate }}</span>
                            }
                    </li>

                    <p class="flex gap-2 text-sm text-gray-500 pt-5">
                        {{ 'i18n.app.features.pages.front-pages.common.fp-order-panel.fp-order-tracking.p_02' | translate }}
                    </p>
                </div>
            }
        </div>

        <ng-template #tp_order_code>
            <corp-input-mask 
                [corp-loading]="_orderTrackingService.loading$()"
                    [formControlName]="'orderCode'"
                    corp-placeholder="XXX-000000-****-*******"
                    corp-mask="XXX-000000-****-*******">
            </corp-input-mask>
        </ng-template>
    </form>
